// Single source of truth for button styles across the portal's "manage"
// surfaces (toolbars + forms). Each page spreads `...btns` into its local
// `cls` style object so the four button roles stay identical everywhere.
//
// steward-app#2509: `btn` and `btnPrim` (Continue, Back, every dialog action built on them) are at
// least 44px tall below `sm` so they are a fair phone tap target; from `sm` up density is unchanged.
// This is app-wide on phones, since these two are the shared primitives.
//
// btnPrim uses `bg-navy text-cream` (not `bg-ink text-white`). `ink` is frozen
// at dark navy in both themes, so a filled ink button blends into the dark-mode
// page background (#15171D) and reads weaker than the outline buttons beside it.
// `navy`/`cream` both flip with the theme, so the primary fill inverts —
// dark-on-light in light mode, light-on-dark in dark mode — and keeps strong
// contrast either way.
export const btns = {
  btn:       'px-4 py-2 text-[11px] font-semibold rounded-token border border-line-strong cursor-pointer bg-transparent text-navy uppercase tracking-[0.08em] font-sans max-sm:min-h-11',
  // `disabled:` variant added by steward-app#1271 (code review): same gap #417 round 2
  // fixed on `btnDanger` below, reintroduced here — `FirmWorkspaceNotReady`'s "Check
  // again" is the first `btnPrim` consumer to pass `disabled`, and without this it was
  // pixel-identical enabled or not, silently swallowing a click on the button that was
  // supposed to show the recheck was in flight. No effect on any other `btnPrim`
  // consumer, none of which pass `disabled` today.
  btnPrim:   'px-5 py-2 text-[11px] font-bold rounded-token border-none cursor-pointer bg-navy text-cream uppercase tracking-[0.1em] font-sans disabled:opacity-50 disabled:cursor-not-allowed max-sm:min-h-11',
  btnSm:     'px-3 py-[5px] text-[11px] font-semibold rounded-token border border-line-strong cursor-pointer bg-transparent text-navy uppercase tracking-[0.06em] font-sans',
  // `disabled:` variants added by steward-app#417 round 2 (code review): this class had
  // none, so a `disabled` danger button was pixel-identical to an enabled one — silently
  // swallowing clicks with no visual cue. `ConnectedAccounts.tsx` had already worked
  // around the gap with its own local override; centralizing it here covers every other
  // `btnDanger` consumer too, none of which pass `disabled` today, so this changes
  // nothing for them until one does.
  btnDanger: 'px-3 py-[5px] text-[11px] font-semibold rounded-token border-none cursor-pointer bg-danger/8 text-danger uppercase tracking-[0.06em] font-sans disabled:opacity-50 disabled:cursor-not-allowed',
};
